import React, { Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import SimpleIframePage from "components/pages/SimpleIframePage";
import ErrorBoundary from "components/organisms/ErrorBoundary/ErrorBoundary";
import { RedirectPage } from "components/pages/RedirectPage";
import SmartLayout from "components/templates/SmartLayout";
import useGlobalContext from "hooks/useGlobalContext";
import moment from "moment";
import { useOrgSlugContext } from "context/OrgSlugContextProvider";

import routes, {
  profileRoutes,
  redirects,
  templateSiteRoute,
  templateCompanySiteRoute,
  home,
} from "./routemap";
import "react-toastify/dist/ReactToastify.css";
import IRoute from "./interfaces/IRoute";
import NullComponent from "./components/templates/NullComponent";

const ScrollToTop = React.lazy(() =>
  import("./components/templates/ScrollToTop"),
);
const TemplateSitePage = React.lazy(() =>
  import("./components/templateSite/TemplateSitePage/TemplateSitePage"),
);

const NotFoundPage = React.lazy(() =>
  import("./components/pages/NotFoundPage"),
);

const MainFooter = React.lazy(() =>
  import("./components/organisms/MainFooter/MainFooter"),
);

const MainHeader = React.lazy(() =>
  import("./components/organisms/MainHeader/MainHeader"),
);

const App: React.FC = () => {
  const { loading, slugs } = useOrgSlugContext();
  const {
    locale: { currentLocale },
  } = useGlobalContext();
  moment.locale(currentLocale);

  return (
    <Suspense fallback={<NullComponent />}>
      <ScrollToTop>
        <Switch>
          {/* TODO restrict this to iframe.latviesi.com */}
          <Route exact path="/iframe" component={SimpleIframePage} />
          {!loading && (
            <Route
              exact
              path={slugs.map((item) => `/${item.name}/:page?`)}
              component={TemplateSitePage}
            />
          )}
          <Route
            exact
            path="/3x3filma"
            component={() => (
              <Redirect to="/video-galerijas/dokumentala-filma-trisreiztris-pasaules-latviesu-gimenu-kustiba-skatama-latviesiem-visa-pasaule" />
            )}
          />
          <Route
            exact
            path="/aptauja"
            component={() => (
              <RedirectPage href="https://aptauja.migracija.lv/index.php?r=survey/index&sid=655578&lang=lv&ref=lc" />
            )}
          />
          {redirects.map((redirect) => (
            <Redirect
              exact
              key={`${redirect[0]}-${redirect[1]}`}
              from={redirect[0]}
              to={redirect[1]}
            />
          ))}
          <Route exact {...templateSiteRoute} />
          <Route exact {...templateCompanySiteRoute} />
          <Route>
            <MainHeader>
              <SmartLayout>
                <ErrorBoundary main>
                  <Suspense fallback={<NullComponent />}>
                    <Switch>
                      {/* Remove me */}
                      <Route {...profileRoutes} />
                      <Route path="/registreties" component={home.component} />
                      {routes.map((route: IRoute) => (
                        <Route exact {...route} key={route.name} />
                      ))}
                      <Route component={NotFoundPage} />
                    </Switch>
                  </Suspense>
                </ErrorBoundary>
              </SmartLayout>
              <MainFooter />
            </MainHeader>
          </Route>
        </Switch>
      </ScrollToTop>
    </Suspense>
  );
};

export default App;
